import { SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX } from "./mutations";

const initialState = {
  forecastMaintenanceAndGrowthCapex: null
};

const forecastMGCReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX:
      return { ...state, forecastMaintenanceAndGrowthCapex: payload }

    default:
      return state;
  }
};

export default forecastMGCReducer;
